import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import trophyImage from "../../assests/images/rank-trophy.png";
import msgIco from "../../assests/images/msg-ico.png";
import download1Image from "../../assests/images/download (1).png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import DownloadIcon from "@mui/icons-material/Download";
import { rfqServices } from "../../services/rfqServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { isEmptyDash, urlConstants, trimString, returnRateVal } from "../../constant";
import RfqExtendValidaityModal from "../common/rfqExtendValidaityModal";
import RfqExitingVendor from "../common/rfqExitingVendorModal";
import ConfirmModal from "../common/rfqConfirmModal";
import { UserObj } from "../../services/localStarage";
import SupportChat from "../support/chat";
import _ from "lodash";
import PackageDocuments from "../projectManagerScreens/packageDocuments";
import { strToDate } from "../../constant";
import { onboardingServices } from "../../services/onboardingServices";
import Tooltip from '@mui/material/Tooltip';
import back from "../../assests/images/back.png";
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ComparisonroundoneCommercial() {

  const { id } = useParams();
  const [commercialEvaluationDetails, setCommercialEvaluationDetails] = React.useState({
    boqs: [],
    rfqVendors: [],
  });
  const [activeChatVendorId, setActiveChatVendorId] = useState("");
  const [showalldocuments, setshowalldocuments] = React.useState(false);
  const [opencreaterfqnewtoggler, setOpenCreateRfqnewToggler] = useState("Header");

  const [opnextendvalidtymodal, setOpnExtendValidtyModal] = useState(false);
  const [rfqNumber, setRfqNumber] = useState('');
  const [currentRfqValidity, setCurrentRfqValidity] = useState({ from: "", to: "" });
  const [newValidityPeriod, setNewValidityPeriod] = useState("");
  const [currentValidityPeriod, setCurrentValidityPeriod] = useState("");
  const [newRfqValidity, setNewRfqValidity] = useState({ from: "", to: "" });
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});
  const [openDownloadResultmodal, setOpenDownloadResultModal] = useState(false);
  const [selectedCheckBox, setSelectedCheckBox] = useState("");
  const [rfqDetails, setRfqDetails] = React.useState({
    boqs: [],
    documents: [],
    rounds: [],
    rfqVendors: [],
    rfqValidity: { "from": null, "to": null },
  });
  const [isEditRFQ, setIsEditRFQ] = useState(false);

  const [existingVendor, setexistingVendor] = useState("");
  const [existingVendorDataList, setexistingVendorDataList] = useState("");
  const [selectedVendorIds, setSelectedVendorIds] = useState({});
  const [status, setStatus] = useState('');

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isVendorChatBoxOpen, setIsVendorChatBoxOpen] = useState(false);
  const [VendorParticipationStatus, setVendorParticipationStatus] = useState(false);
  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  useEffect(() => {
    getCommercialComparison(id);
    getRFQDetails(id);
  }, []);

  const getRFQDetails = (param) => {
    setIsLoading(true);
    let data = `/${param}`;
    let promise = rfqServices.getRfqListing(data);

    promise.then((res) => {
      if (res.data.success === true) {
        setRfqDetails(res.data?.data);
        const isVendorParticipationStatus = res.data?.data?.rfqVendors?.some(
          (vendor) => vendor.participationStatus === "Submitted"
        );
        setVendorParticipationStatus(isVendorParticipationStatus);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }


  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const getCommercialComparison = (param) => {
    setIsLoading(true);
    let round = 1;
    let promise = rfqServices.getCommercialComparison(param,round);

    promise.then((res) => {
      if (res.data.success === true) {
        let resData = res.data.data;
        for (let i = 0; i < resData?.rfqVendors.length; i++) {
          let arr = [];
          for (let j = 0; j < resData?.documents.length; j++) {
            for (let k = 0; k < resData?.rfqVendors[i]?.documents.length; k++) {
              if (resData?.documents[j]?.uniqueName == resData?.rfqVendors[i]?.documents[k]?.uniqueName) {
                arr.push(resData?.rfqVendors[i]?.documents[k]);
              }              
            }
          }
          // console.log("getCommercialComparison", arr);
          resData.rfqVendors[i].documents = arr;
        }
        // resData["boqTableArr"] = createTableArr(res.data.data);
        setCommercialEvaluationDetails(resData);
        setActiveChatVendorId(resData?.rfqVendors?.[0]?.vendorId);
        // setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getRfqVendorBoqByBoqId = (boqId, rfqVendorsBoqsArr) => {
    let obj = {};
    for (let i = 0; i < rfqVendorsBoqsArr.length; i++) {
      if (boqId == rfqVendorsBoqsArr[i]?.boqId) {
        obj["data"] = rfqVendorsBoqsArr[i];
        obj["index"] = i;
      }
    }
    return obj;
  }

  const onTextChange = (e, data, index) => {
    let { name, value } = e.target;
    let rfqVendorsInit = _.cloneDeep(commercialEvaluationDetails?.rfqVendors);
    rfqVendorsInit[index]["commercialFields"][name] = value;
    setCommercialEvaluationDetails(prevState => ({
      ...prevState,
      rfqVendors: [...rfqVendorsInit]
    }));
  }

  const onExtendValidity = (boqId, rfqVendorsBoqsArr) => {
    setRfqNumber(rfqDetails?.rfqNumber);
    const dateString = rfqDetails?.rfqValidity?.from;
    const date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    const fromDate = date.toISOString().split('T')[0];

    const datetoString = rfqDetails?.rfqValidity?.to;
    const toDate = new Date(datetoString);
    toDate.setHours(0, 0, 0, 0);
    const toDDate = toDate.toISOString().split('T')[0];

    setCurrentRfqValidity({
      from: fromDate,
      to: toDDate
    })
    setOpnExtendValidtyModal(true);
  }

  const handleNewDatePickerChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      setNewRfqValidity({
        from: dateStrings[0],
        to: dateStrings[1]
      });

      const fromDate = new Date(dateStrings[0]);
      const toDate = new Date(dateStrings[1]);
      const differenceInTime = toDate.getTime() - fromDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      if (differenceInDays < 30) {
        setNewValidityPeriod(`${differenceInDays} Days`);
      } else {
        const differenceInMonths = differenceInDays / 30;
        const differenceInYears = differenceInMonths / 12;
        setNewValidityPeriod(`${differenceInYears.toFixed(1)} Years`);
      }
    }
  };

  const closeExtendValidty = () => {
    setOpnExtendValidtyModal(false);
    setNewValidityPeriod('');
  }

  const handleSubmit = () => {
    setIsLoading(true);
    let bodydata = {
      "rfqValidity": { from: newRfqValidity.from, to: newRfqValidity.to },
      "rfqNumber": rfqNumber,
    }
    let reqId = id;
    if (reqId) {
      rfqServices.extendValidity(reqId, bodydata)
        .then((res) => {
          if (res && res.data) {
            setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
            setOpnExtendValidtyModal(false);
            setNewValidityPeriod('');
            window.location.reload();
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          });
          // setIsConfirmModalOpen(false);
        })
        .finally(() => {
          setIsLoading(false);
        });

    }
  };

  const setOpenRfqExitingVenodr = () => {
    setexistingVendor(true);
  }

  const closeExitingVendorModal = () => {
    setexistingVendor(false);
  };

  const getExistingVendorRfqList = (requestPayloadParam, filterTextParam) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    rfqServices
      .getExistingVendorRfqListing(param)
      .then((res) => {
        if (res && res.data) {
          setexistingVendorDataList(res.data)
        } else {
          setAlertComponent({ open: true, type: 'error', message: 'No Data Found', });
        }
      })
      .catch((error) => {
        setAlertComponent({ open: true, type: 'error', message: `${error?.response?.data?.message}`, });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCheckboxChange = (vendorId, isChecked, page) => {
    setSelectedVendorIds(prevState => {
      const updatedState = { ...prevState };
      if (!updatedState[page]) {
        updatedState[page] = new Set();
      }
      if (isChecked) {
        updatedState[page].add(vendorId);
      } else {
        updatedState[page].delete(vendorId);
      }
      return updatedState;
    });
  };

  const submitExistingVendorId = (param) => {
    const allSelectedVendorIds = Object.values(selectedVendorIds).reduce((acc, set) => {
      return acc.concat(Array.from(set));
    }, []);

    extendVendor(param, allSelectedVendorIds);
  }

  const extendVendor = (param, vendorArr) => {
    setIsLoading(true);

    let bodyData = {
      "isSubmitting": param, // true for Created
      "isExtendedVendor": true, //for extending vendors after submitting rfq
      "purchaseType": rfqDetails?.purchaseType,
      "remarks": rfqDetails?.remarks,
      "rfqValidity": rfqDetails?.rfqValidity,
      // "vendorIds": ["66585701a115961624b0d6ad"],
      "vendorIds": vendorArr,
      "boqs": rfqDetails?.boqs,
      "documents": rfqDetails?.documents,
    }


    rfqServices?.updateRFQ(id, bodyData)
      .then((res) => {
        if (res.data.success === true) {
          // setPackageDetailCreationlist(res.data.data);
          // getRFQVendorDetails(id);
          // setOpenBoqUpdateSuccessfully(false);
          // setCreatedNewRFQNo(`${res.data?.data?.rfqNumber} `)
          setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, });
          // setCreateVendorOpen(false);
          setexistingVendor(false);
          // navigateUrl(`/admin/Project-Manager-Packages-Listing`);
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const closeRfq = (param) => {
    let bodyData = {
      "status": "Close"
    };
    rfqServices?.changeStatus(id, bodyData)
      .then((res) => {
        if (res.data.success === true) {
          setAlertComponent({ open: true, type: "success", message: `${res.data?.message} `, });
        } else {
          setAlertComponent({ open: true, type: "error", message: `No Data Found `, });
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  const [hasRedirected, setHasRedirected] = useState(false);
  const navigate = useNavigate();

  const downloadRfqResult = (param) => { 
    if(commercialEvaluationDetails?.approvalFlow === "Simultaneous" && commercialEvaluationDetails?.activeRound?.technicalStatus !== 'Completed'){
      setAlertComponent({ open: true, type: "error", message: "Technical evaluation is not completed", });
      return false;
    }
    setIsLoading(true);
    let bodyData = {
      "type": selectedCheckBox,
    };

    let url = `${urlConstants.BASE_URI_DEV}/v1/internal/rfqs/${id}/commercial-comparison/download`;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${UserObj?.accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(bodyData);

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(url, requestOptions)
      .then(response => response.blob())
      .then(async blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let fileName = "";
        if (selectedCheckBox == "Pdf") {
          fileName = `Bidding-R1-${rfqDetails?.rfqNumber}.pdf`;
        }
        if (selectedCheckBox == "Excel") {
          fileName = `Bidding-R1-${rfqDetails?.rfqNumber}.xlsx`;
        }
        if (selectedCheckBox == "Both") {
          fileName = `Bidding-R1-${rfqDetails?.rfqNumber}.zip`;
        }
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        await onFinalizeSubmit();
        // Redirect only if it has not already been redirected
        if (!hasRedirected) {
          setHasRedirected(true);
         navigate(`/admin/Engineering-Bidding-Rfq-Listing`);
          window.location.reload();
        }
      })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}`, });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const onFinalizeSubmit = (e) => {
    setIsLoading(true);
    let bodyData = {
      "type": "Commercial",
      "round": 1
    };
    let promise = rfqServices.techFinalize(id, bodyData);

    promise.then((res) => {
      if (res.data.success === true) {
        setOpenDownloadResultModal(false);
        setAlertComponent({ open: true, type: "success", message: `${res.data.message}` });
        // window.location.reload();
        // setOpenFinalizeEvaluationSuccessfully(true);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const updateVendorSubmit = (e) => {
    setIsLoading(true);
    let bodyData = {
      "vendorData": [],
      "round": 1
    };
    let validObj = {
      isValid: true,
      vendorName: "",
      secName: "",
    };
    for (let index = 0; index < commercialEvaluationDetails?.rfqVendors.length; index++) {
      let obj = {
        "vendorId": commercialEvaluationDetails?.rfqVendors[index]?.vendorId,
        "commercialFields": commercialEvaluationDetails?.rfqVendors[index]?.commercialFields,
      }
      bodyData.vendorData.push(obj);
      let commercialInit = commercialEvaluationDetails?.rfqVendors[index]?.commercialFields;
      let isValidEle = true;
      for (let data in commercialInit) {
        if (isEmptyDash(commercialInit[data])) {
          isValidEle = false;
          validObj["isValid"] = false;
          validObj["secName"] = data;
          validObj["vendorName"] = commercialEvaluationDetails?.rfqVendors[index]?.vendorName;
          break;
        }
      }
      if (isValidEle == false) {
        break
      }
    }
    if (validObj["isValid"] == false) {
      let name = "";
      switch (validObj["secName"]) {
        case "capacity":
          name = "Capicity"
          break;
        case "defectLiabilityPeriod":
          name = "Defect Liability Period"
          break;
        case "liquidatedDamages":
          name = "Liquidated Damages"
          break;
        case "overAllLdCap":
          name = "Over All LD Cap"
          break;
        case "paymentTerms":
          name = "Payment Terms"
          break;
        case "serviceContractPeriod":
          name = "Service Contract Period"
          break;
        case "warranty":
          name = "Warranty"
          break;

        default:
          break;
      }
      setAlertComponent({ open: true, type: "error", message: `${name} cannot be empty for vendor "${validObj["vendorName"]}".` });
      setIsLoading(false);
      return;
    }


    let promise = rfqServices.updateVendorDetails(id, bodyData);
    promise.then((res) => {
      if (res.data.success === true) {
        window.location.reload();
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const dummyFun = (param) => {
  };

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  const handleClick = (document, index) => {
    setUploadFilesObj(document);
    setIsMediaListModalOpen(true);
  }

  const onSelectedCheckBox = (e, param) => {
    setSelectedCheckBox(param);
  }

  const vendorChatBoxClick = (vendorId) => {
    setActiveChatVendorId(vendorId);
    setIsVendorChatBoxOpen(true); /** for chatbox open from vendor side */
  }

  const handleChatboxMinimize = () => {
    setIsVendorChatBoxOpen(false);
  };


  const downloadAttachment = (data, fileNameParam, secName, vendorIndex, attachmentIndex) => {
    setIsLoading(true);
    onboardingServices.viewUrlData(data).then(function (response) {
      const url = response?.data?.data?.url;
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileNameParam;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(error => console.error('Error downloading Doc:', error))
        .finally((param) => {
          setIsLoading(false);
        });
    });
  }


  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="listing_projectss">
            <p className="listing_rfq">
              <div class="div-details-center react_technical_vendordetail22">
                <button
                  onClick={() => navigate(-1)}
                  class=""
                  style={{
                    padding: "9px 16px",
                    marginRight: "11px",
                    fontSize: "18px",
                    background: "black",
                  }}
                >
                  <img
                    src={back}
                    alt="back-button"
                    style={{ paddingRight: "3px" }}
                  />{" "}
                  Back
                </button> </div>Commercial Comparison
              <strong className="bidding_round_rfq">- Bidding Round 1</strong>
            </p>
            <div className="extend_evaluation">
              {/* <button
                className="btn btn-danger"
                fdprocessedid="k4yyb6"
                onClick={() => setIsConfirmModalOpen(true)}
              >
                Close RFQ
              </button>
              <button
                className="vendor_btn vendor_maine_content2"
                fdprocessedid="k4yyb6"
                onClick={onExtendValidity}
              >
                Extend Validity
              </button>
              <button
                className="vendor_btn vendor_maine_content2"
                fdprocessedid="31fkt"
                onClick={setOpenRfqExitingVenodr}
              >
                Extend Vendor
              </button> */}
              <button
                className="btn btn-success save_next_btns"
                disabled={!VendorParticipationStatus === true && rfqDetails?.rfqType === 'ONE_BID'}
                onClick={() => {
                  setOpenDownloadResultModal(true)
                }}
              >
                <DownloadIcon />
                Download Result
              </button>
              {/* {(isEditRFQ != true) && <button className=" btn-edit-buttons_block" onClick={() => setIsEditRFQ(true)}>
                <EditIcon fontSize="30" />
                Edit
              </button>} */}
            </div>
          </div>
          <div class="header_lineitem">
            <span
              onClick={() => setOpenCreateRfqnewToggler("Header")}
              class={
                opencreaterfqnewtoggler === "Header"
                  ? "line-tb"
                  : "header-tb"
              }
            >
              Header
            </span>
            <span
              onClick={() => setOpenCreateRfqnewToggler("LineItems")}
              class={
                opencreaterfqnewtoggler === "LineItems"
                  ? "line-tb"
                  : "header-tb"
              }
            >
              Line Items
            </span>
          </div>
          <div className="row1_firstcommercial_bpdt_section_react_roq">
            <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body_row2" style={{ tableLayout: 'fixed' }}>
              <thead>
                <tr className="line_time_rfq_project_detail_body">
                  <th className="boq_detail_technical_package_react" style={{ width: '32px' }}>No</th>
                  <th className="boq_detail_technical_package_react" style={{ width: '126px', textAlign: 'center' }}>BOQ</th>
                  <th className="boq_detail_technical_package_react">QTY</th>
                </tr>
              </thead>
              <tbody>

                {commercialEvaluationDetails?.boqs?.map((boqsEle, i) => <>
                  <tr>
                    <td className="">{i + 1}</td>
                    <td className="vendor_c_reacts_package_blocklist_trews">
                      <p>
                        <Tooltip title={boqsEle?.description}>
                          <b>{trimString(boqsEle?.description, 12)}</b>
                        </Tooltip>
                      </p>
                    </td>
                    <td>{boqsEle?.quantity}</td>
                  </tr>
                </>)}


                <tr>
                  <td className="vendor_f_react_body_list_detail"></td>
                  <td className="vendor_f_react_body_list_detail">
                    <h2 className="lets_total_reactdetail_blocklist_roundq">
                      Total
                    </h2>
                  </td>
                  <td className="vendor_f_react_body_list_detail">
                    <h2 className="lets_total_reactdetail_blocklist_roundq">
                      {commercialEvaluationDetails?.totalQuantity}
                    </h2>
                  </td>
                </tr>
                {/* <tr className="custom-borders">
                  <td className="border-top border-bottom text-end">
                    <p className="tender_drawing_f">
                      <b>Tender Drawing</b>
                    </p>
                    <p className="tender_drawing_f">
                      <b style={{ fontSize: "13px" }}>Technical Specification</b>
                    </p>
                  </td>
                  <td></td>
                </tr> */}

                {/* <tr class="custom-borders">
                  <td class="border-top border-bottom  technical_soon_div_tdf_reacts">
                    <input type="checkbox" />

                    <p className="tender_drawing_f">
                      <b>Payment Terms</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Liquidated Damages</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Over all LD cap</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Defect Liability Period</b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Service Contract </b>
                    </p>
                  </td>
                  <td></td>
                </tr>

                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"
                    style={{ height: "49px" }}
                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Warrenty</b>
                    </p>
                  </td>
                  <td></td>
                </tr>
                <tr class="custom-borders">
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"

                  >
                    <input type="checkbox" />
                    <p className="tender_drawing_f">
                      <b>Capacity</b>
                    </p>
                  </td>
                  <td></td>
                </tr> */}

                <tr class="custom-borders">
                  <td></td>
                  <td
                    class="border-top border-bottom  technical_soon_div_tdf_reacts"

                  >

                    <p className="tender_drawing_fs" onClick={() => setshowalldocuments(!showalldocuments)}>
                      <b >View All Attachment</b>
                      {showalldocuments ? <RemoveIcon /> : <AddIcon />}
                    </p>
                  </td>
                  <td style={{ border: "none" }}></td>
                </tr>
                {showalldocuments ? <>

                  {commercialEvaluationDetails?.documents?.map((rfqVendorsDocEle, i) => <>
                    <tr class="custom-borders">
                      <td></td>
                      <td
                        class="border-top border-bottom technical_soon_div_tdf_reacts"
                        style={{ height: "50px" }}
                      >

                        <p className="tender_drawing_f">
                          <Tooltip title={rfqVendorsDocEle?.documentName}> <b>{trimString(rfqVendorsDocEle?.documentName, 13)}</b></Tooltip>
                        </p>
                      </td>
                      <td></td>
                    </tr>
                  </>)}

                </> : null}

              </tbody>
            </table>

            <div className="react_row_table_technical_body">
              <table className="table table-bordered tble-sty vendor_rfqdetail_technical_body ">
                <thead>
                  <tr className="line_time_rfq_project_detail_body">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <th className="lets_oty_listing_detail_r_line" style={(rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected') ? { backgroundColor: '#808080ad' } : {}}>
                        <div className="vendor_b_react_package_blocklist_body">
                          <p className="vendor_a_react_body_list">{rfqVendorsEle?.vendorName}</p>
                          <div>
                            {/* <span className="rank-trophy">{j+1}</span> */}
                            {/* <span onClick={() => setActiveChatVendorId(rfqVendorsEle?.vendorId)}> */}
                            <span onClick={() => vendorChatBoxClick(rfqVendorsEle?.vendorId)}>
                              <img className="msgIco-img" src={msgIco} alt="" />
                            </span>

                            {(opencreaterfqnewtoggler == "Header") && <div>
                              <span className="rank-trophy">{j + 1}</span>
                              <span>
                                <img className="rank-trophy-img" src={trophyImage} alt="" />
                              </span>
                            </div>}
                          </div>


                        </div> 
                        {rfqVendorsEle?.technicalStatus === 'Rejected' ? 'Technical Evaluation : Rejected' : '' || rfqVendorsEle?.participationStatus === 'Rejected' ? 'Participation Status: Rejected' : ''}

                        {rfqVendorsEle?.technicalStatus === 'Rejected' && (
                          <p>Remarks : <Tooltip title={rfqVendorsEle?.vendorData?.[0]?.technicalApproval?.feedback}>{trimString(rfqVendorsEle?.vendorData?.[0]?.technicalApproval?.feedback,15)  }</Tooltip> </p>  
                        ) }
 
                        <p class="bidding_block_sky">{strToDate(rfqVendorsEle?.updatedAt)}</p>
                        <div className="bidding_buyer_initeate_react_body">
                          <div className="rate_evalulation_listing_react_body">
                            <div>
                              <h6>Rate</h6>
                            </div>
                            <div className="round_listing">
                              <h6>Amount</h6>
                            </div>
                          </div>
                        </div>
                      </th>
                    </>)}

                  </tr>
                </thead>
                <tbody>

                  {commercialEvaluationDetails?.boqs?.map((boqsEle, i) => <>
                    <tr>
                      {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>

                        <td style={(rfqVendorsEle?.technicalStatus === 'Rejected' || rfqVendorsEle?.participationStatus === 'Rejected') ? { backgroundColor: '#808080ad' } : {}}>
                          {" "}
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">
                              <span class="bidding_block_rate ">
                                {/* ₹ {isEmptyDash(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate) ? 0 : getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate} */}
                                {returnRateVal(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rate)}
                              </span>
                            </div>

                            <div className="evaluation_react_bvfdt_div_block1">
                              <span class="bidding_block_rate ">
                                {/* ₹ {isEmptyDash(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount) ? 0 : getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount} */}
                                {returnRateVal(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.amount)}
                              </span>
                              {/* <span class="bidding_block_rate "></span> */}
                              {(opencreaterfqnewtoggler == "LineItems") && <>
                                {!(isEmptyDash(getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rank)) && <div>
                                  <span className="rank-trophy">
                                    {getRfqVendorBoqByBoqId(boqsEle?._id, rfqVendorsEle?.boqs[0]?.boqData)?.data?.rank}
                                  </span>
                                  <span>
                                    <img className="rank-trophy-img" src={trophyImage} alt="" />
                                  </span>
                                </div>}
                              </>}
                            </div>

                            {/* <div className="evaluation_react_bvfdt_div_block1">
                              
                            </div> */}

                          </div>
                        </td>
                      </>)}
                    </tr>
                  </>)}


                  <tr>

                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td className="vendor_f_react_body_list_detail" >
                        <div className="total_vendor_round_detail_panel_q">
                          <h2 className="lets_total_reactdetail_blocklist_roundq"></h2>
                          <h2 className="lets_total_reactdetail_blocklist_roundq me-4 ">
                            {/* ₹{rfqVendorsEle?.boqs[0]?.totalAmount} */}
                            {returnRateVal(rfqVendorsEle?.boqs[0]?.totalAmount)}
                          </h2>
                        </div>
                      </td>

                    </>)}

                  </tr>
                  {/* <tr className="custom-borders"> 
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, i) => <>
                      <td>
                        <div className="lets_customs_div_reacts_round1">
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">

                              {(rfqVendorsEle?.tendorDrawing?.length < 1) && <>
                                <p className="tender_drawing_f">Empty</p>
                              </>}
                              {rfqVendorsEle?.tendorDrawing?.map((attachmentEle, j) => <>
                                <p className="tender_drawing_f" onClick={() => downloadAttachment(attachmentEle?.key, attachmentEle?.fileName, "tendorDrawing", i, j)}>
                                  {attachmentEle?.fileName} <img src={download1Image} alt="" />
                                </p>
                              </>)}

                            </div>
                          </div>

                        </div>
                        <div className="lets_customs_div_reacts_round1">
                          <div className="d-flex justify-content-between">
                            <div className="evaluation_react_bvfdt_div_block1">
                              {(rfqVendorsEle?.technicalSpecification?.length < 1) && <>
                                <p className="tender_drawing_f">Empty</p>
                              </>}
                              {rfqVendorsEle?.technicalSpecification?.map((attachmentEle, j) => <>
                                <p className="tender_drawing_f" onClick={() => downloadAttachment(attachmentEle?.key, attachmentEle?.fileName, "technicalSpecification", i, j)}>
                                  {attachmentEle?.fileName}<img src={download1Image} alt="" />
                                </p>
                              </>)}
                            </div>
                          </div>
                          <p class="yes_technical_project_react_body1se">
                              Approve
                            </p>  
                        </div>
                        <p class="yes_technical_project_react_body1se">
                          <span> {rfqVendorsEle?.technicalStatus}</span>
                        </p>
                      </td>
                    </>)} 
                  </tr> */}

                  {/* <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="paymentTerms"
                              value={rfqVendorsEle?.commercialFields?.paymentTerms}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}

                  </tr>

                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="liquidatedDamages"
                              value={rfqVendorsEle?.commercialFields?.liquidatedDamages}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>

                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="overAllLdCap"
                              value={rfqVendorsEle?.commercialFields?.overAllLdCap}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="defectLiabilityPeriod"
                              value={rfqVendorsEle?.commercialFields?.defectLiabilityPeriod}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="serviceContractPeriod"
                              value={rfqVendorsEle?.commercialFields?.serviceContractPeriod}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="warranty"
                              value={rfqVendorsEle?.commercialFields?.warranty}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr>
                  <tr class="custom-borders">
                    {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                      <td>
                        <div className="d-flex justify-content-between">
                          <div className="evaluation_react_bvfdt_div_block1">
                            <input
                              type="text"
                              class="form-control form-haseqw"
                              fdprocessedid="8l6zt"
                              placeholder=""
                              name="capacity"
                              value={rfqVendorsEle?.commercialFields?.capacity}
                              onChange={(e) => onTextChange(e, rfqVendorsEle, j)}
                              disabled={!(isEditRFQ == true)}
                            />
                          </div>
                        </div>
                      </td>
                    </>)}
                  </tr> */}
                  <tr class="custom-borders" style={{ height: "61px" }}>
                    {/* <td style={{border: "none"}}>
                      <div className="d-flex justify-content-between">
                        <div className="evaluation_react_bvfdt_div_block1">
                     
                        </div>
                      </div>
                    </td>

                    <td style={{border: "none"}}>
                      <div className="d-flex justify-content-between">
                        <div className="evaluation_react_bvfdt_div_block1">
                       
                        </div>
                      </div>
                    </td>

                    <td  style={{border: "none"}}>
                      <div className="d-flex justify-content-between">
                        <div className="evaluation_react_bvfdt_div_block1">
                    
                        </div>
                      </div>
                    </td> */}
                  </tr>
                  {showalldocuments ? <>

                    {commercialEvaluationDetails?.rfqVendors[0]?.documents?.map((rfqVendorsDocEle, i) => <>
                      <tr class="custom-borders">
                        {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, j) => <>
                          <td>
                            {/* <span>
                              <p className="rejected_text_table_redfm">Rejected</p>
                            </span> */}
                            <button className="file-upload-btn comparison-file-upload-btn" disabled=""
                              onClick={() => handleClick(rfqVendorsEle?.documents[i], i)}
                            >View</button>
                            {
                              rfqVendorsEle?.documents[i]?.response[0]?.acknowledged === true ? (
                                <span style={{ fontSize: '10px', color: 'red' }}>✔️</span>
                              ) : rfqVendorsEle?.documents[i]?.response[0]?.acknowledged === false ? (
                                <>
                                  <span style={{ fontSize: '10px', color: 'red', paddingRight: '10px' }}>✖️</span>
                                  <span
                                    className="download-text"
                                    onClick={() =>
                                      downloadAttachment(
                                        rfqVendorsEle?.documents[i]?.response[0]?.vendorResponse?.key,
                                        rfqVendorsEle?.documents[i]?.response[0]?.vendorResponse?.fileName,
                                        rfqVendorsEle?.documents[i]?.uniqueName,
                                        i,
                                        j
                                      )
                                    }
                                  >
                                    <img src={download1Image} alt="" />
                                  </span>
                                </>
                              ) : (
                                <span style={{ fontSize: '10px', paddingLeft: '10px' }}>N/A</span>
                              )
                            }
                          </td>
                        </>)}
                      </tr>
                    </>)}

                    {/* <tr class="custom-borders">
                    <td>
                      <div className="d-flex justify-content-between">
                        <div className="evaluation_react_bvfdt_div_block1">
                        <p className="rejected_text_table_redfm">Rejected</p>
                        <AttachFileIcon  style={{color:"#B9AFAF"}}/>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="d-flex justify-content-between">
                        <div className="evaluation_react_bvfdt_div_block1">
                        <p className="rejected_text_table_redfm">Rejected</p>
                        <AttachFileIcon  style={{color:"#B9AFAF"}}/>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="d-flex justify-content-between">
                        <div className="evaluation_react_bvfdt_div_block1">
                        <p className="rejected_text_table_redfm">Rejected</p>
                        <AttachFileIcon  style={{color:"#B9AFAF"}}/>
                        </div>
                      </div>
                    </td>
                  </tr> */}

                    {/* <tr class="custom-borders">
                    <td style={{border: "none"}}>
                     
              
                    </td>
                 
                    <td style={{border: "none"}}>
                  
              
                    </td>
                   
                    <td style={{border: "none"}}>
                      <div className="btn custome_vendor_subnu_react_div">
                      <button type="button" class="btn btn-danger" fdprocessedid="7lvn2c">Discard </button>
                      <button type="button" class="btn-btn-submit_boq-div_commercial" fdprocessedid="u8jto">Submit</button>
                      </div>
              
                    </td>

                   
                  </tr> */}
                  </> : null}

                </tbody>
              </table>
            </div>
          </div>
          {/* 
          <div class="comments_main">
            <h3>Comments</h3>
            <div class="comments_main_in">
              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input type="text" placeholder="Type comments..." />

                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="epy4fp"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>

              <div class="comments_in">
                <div class="jobw_well">You did your job well!</div>
                <div class="time-am">9:25 AM</div>

                <div class="icon_type">
                  <img src={jobwellImage} alt="" />
                  <div class="typehere-bx">
                    Please type here for any additional details from Vendors
                  </div>
                </div>

                <div class="bot_just">Bot・Just now</div>

                <div class="type_reply justify-content-between">
                  <input
                    type="text"
                    placeholder="Type comments..."
                    fdprocessedid="5izdv"
                  />
                  <span>
                    <img src={send1Image} alt="" />
                  </span>
                </div>
              </div>
            </div>
          </div>
           */}
          {(isEditRFQ == true) && <div class="clear_btn_status_modified_div_bgft_reacts">
            <button type="button" class="btn btn-danger" onClick={() => getCommercialComparison(id)}>
              Discard
            </button>
            <button type="button" className="btn-btn-udate_boq-div_commercial" onClick={updateVendorSubmit}>
              Submit
            </button>
          </div>}
        </div>
      </div>

      {/* Approve RFQ Publish in RFQ Listing */}
      <Modal
        open={openDownloadResultmodal}
        onClose={() => setOpenDownloadResultModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1} className="modal_react_controlpanel_employees">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Download Result</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              fdprocessedid="kum8iho"
              onClick={() => setOpenDownloadResultModal(false)}
            ></button>
          </div>
          <div class="modal-bodys">
            <div className="rfq-download-result-div">
              <div >
                <span><input name="Pdf" type="checkbox" checked={selectedCheckBox == "Pdf"} onChange={(e) => onSelectedCheckBox(e, "Pdf")} /> </span>
                <span>PDF </span>
              </div>
              <div onClick={() => setSelectedCheckBox("Excel")}>
                <span><input name="Excel" type="checkbox" checked={selectedCheckBox == "Excel"} onChange={(e) => onSelectedCheckBox(e, "Excel")} /> </span>
                <span>Excel </span>
              </div>
              <div onClick={() => setSelectedCheckBox("Both")}>
                <span><input name="Both" type="checkbox" checked={selectedCheckBox == "Both"} onChange={(e) => onSelectedCheckBox(e, "Both")} /> </span>
                <span>Both </span>
              </div>
            </div>
            <div class="lets_no_btn_danger_yes_technical_project">
              <button
                type="button"
                class="btn btn btn-danger"
                onClick={() => {
                  setOpenDownloadResultModal(false);
                }}
                style={{ "marginRight": "5px" }}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${selectedCheckBox ? 'btn-success' : ''}`}
                onClick={downloadRfqResult}
                disabled={!selectedCheckBox}
                variant="contained"
              >
                Submit
              </button>
            </div>
          </div>
        </Box>
      </Modal >

      {(commercialEvaluationDetails?.rfqVendors?.length > 0) && (
        <>
          {commercialEvaluationDetails?.rfqVendors?.map((rfqVendorsEle, i) => <>
            <SupportChat
              vendorDetails={{ vendor: { _id: rfqVendorsEle?.vendorId } }}
              isComparison={true}
              comparisonData={{
                isActive: rfqVendorsEle?.vendorId == activeChatVendorId,
                vendorName: rfqVendorsEle?.vendorName,
                rfqId: id,
                isVendorChatBoxOpen: isVendorChatBoxOpen,
              }}
              onMinimize={handleChatboxMinimize}
            />
          </>)}
        </>
      )
      }

      <RfqExtendValidaityModal
        setOpnExtendValidtyModal={setOpnExtendValidtyModal}
        opnextendvalidtymodal={opnextendvalidtymodal}
        rfqNumber={rfqNumber}
        currentRfqValidity={currentRfqValidity}
        handleNewDatePickerChange={handleNewDatePickerChange}
        newValidityPeriod={newValidityPeriod}
        closeExtendValidty={closeExtendValidty}
        handleSubmit={handleSubmit}
        currentValidityPeriod={currentValidityPeriod}
      />

      <RfqExitingVendor
        existingVendor={existingVendor}
        closeExitingVendorRFQModal={closeExitingVendorModal}
        getExistingVendorRfqList={getExistingVendorRfqList}
        onCheckboxChange={handleCheckboxChange}
        vendorList={existingVendorDataList}
        submitExistingVendorId={submitExistingVendorId}
        selectedVendorIds={selectedVendorIds}
      />

      <ConfirmModal
        isConfirmModalOpen={isConfirmModalOpen}
        closeConfirmModal={closeConfirmModal}
        successConfirmModal={closeRfq}
        modalMsg="Do you want to close this RFQ?"
        status={status}
      />

      <PackageDocuments
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={dummyFun}
        deleteFile={dummyFun}
        isSubmitCondition={false}
        onMediaActionChange={dummyFun}
        acceptAcknowledge={dummyFun}
        isColumn={{
          "DELETE": false,
          "INPUT_UPLOAD": false,
          "STATUS": true,
          "VENDOR_DOC": true,
          "REMARKS": true,
        }}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default ComparisonroundoneCommercial;
